import { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Warning } from '@phosphor-icons/react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { fmtDate } from '@/utils/dateFmt';

const API = process.env.REACT_APP_BACKEND_URL;

export const ConflictReportDialog = ({ open, onClose }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    if (!open) return;
    setData(null); setError('');
    axios.get(`${API}/api/admin/schedule/conflict-report`).then(r => setData(r.data)).catch(() => setError('Não foi possível carregar o relatório.'));
  }, [open]);
  return (
    <Dialog open={open} onOpenChange={o => { if (!o) onClose(); }}>
      <DialogContent className="rounded-3xl border-brand-border max-w-lg max-h-[85vh] overflow-y-auto" data-testid="conflict-report-dialog">
        <DialogHeader><DialogTitle className="font-heading text-brand-text flex items-center gap-2"><Warning size={18} className="text-amber-600" /> Conflitos de horário</DialogTitle></DialogHeader>
        <p className="text-xs text-brand-muted">Consultas futuras que se sobrepõem na mesma nutricionista. Só leitura: nada é alterado. Resolve remarcando ou cancelando no calendário.</p>
        {error && <p className="text-xs text-red-600" data-testid="conflict-report-error">{error}</p>}
        {!data && !error && <p className="text-xs text-brand-muted">A carregar...</p>}
        {data && data.grupos.length === 0 && <p className="text-sm text-brand-green py-4 text-center" data-testid="conflict-report-empty">Sem conflitos nas consultas futuras.</p>}
        {data && data.grupos.length > 0 && (
          <div className="space-y-3" data-testid="conflict-report-list">
            <p className="text-xs font-medium text-brand-text" data-testid="conflict-report-total">{data.total_dias_com_conflito} dia(s) com conflito</p>
            {data.grupos.map((g, i) => (
              <div key={`${g.nutricionista_id}-${g.date}`} className="border border-amber-200 bg-amber-50/50 rounded-2xl p-3" data-testid={`conflict-group-${i}`}>
                <p className="text-xs font-semibold text-brand-text mb-1.5">{fmtDate(g.date)} · {g.nutricionista || 'Nutricionista'}</p>
                <ul className="space-y-1">
                  {g.consultas.map(c => (
                    <li key={c.id} className="text-xs text-brand-text flex items-center justify-between gap-2">
                      <span>{c.time} · {c.patient_name || 'Sem nome'}</span>
                      <Link to={`/admin/calendario?data=${g.date}&hora=${c.time}&apt=${c.id}`} onClick={onClose} className="text-brand-green underline text-[11px]" data-testid={`conflict-open-${c.id}`}>Abrir no calendário</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
